<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="`${conditionsRequirementsField}.${orderItemTypesField}`"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeOrderItemTypesField] ? 'Exclude' : 'Include')} Order Item Types`"
      value-type="Array"
      :options="$mh.asOptions(ORDER_ITEM_TYPES.BOOKING_FEE_CONDITION)"
      map-options
      emit-value
      multiple
      use-chips
      clearable
      :rules="[
        val => !!val || 'Field is required',
        val => val.length > 0 || 'Must select at least one Order Item Type'
      ]"
    />
    <model-form-toggle
      :field="`${conditionsRequirementsField}.${excludeOrderItemTypesField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITIONS_REQUIREMENTS } from 'src/models/booking-fee-type/BookingFeeType'
import { ORDER_ITEM_TYPES } from 'src/models/order-item/OrderItem'

export default {
  name: 'OrderItemTypesConditionForm',
  props: {
    conditional: {
      type: Object,
      required: true
    },
    conditionsRequirementsField: {
      type: String,
      default: 'conditionsRequirements'
    },
    orderItemTypesField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.ORDER_ITEM_TYPES
    },
    excludeOrderItemTypesField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.EXCLUDE_ORDER_ITEM_TYPES
    }
  },
  created () {
    _.extend(this, { ORDER_ITEM_TYPES })
  }
}

</script>
